import { TextFieldViewModel } from '../text-field.viewModel';

import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { SEOTextBlock } from '@/src/cms/domain/models/blocks/seo-text-block';


export class SEOTextBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'seo-text-block' as const;

  title: string;

  body: TextFieldViewModel;

  constructor(data: { title: string; body: TextFieldViewModel }) {
    this.title = data.title;
    this.body = new TextFieldViewModel(data.body);
  }

  static presenter(block: SEOTextBlock): SEOTextBlockViewModel {
    return new SEOTextBlockViewModel({
      title: block.title,
      body: TextFieldViewModel.presenter(block.body)
    });
  }
}
